"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const reviewChoiceKeywordMapping = {
    8: '귀여워요',
    9: '인생 소비예요',
    2: '퀄리티가 좋아요',
    10: '기다린 보람이 있어요',
    11: '친절하고 배려 있어요',
    12: '상세 설명이 자세해요',
    1: '배송 약속을 잘 지켜요',
    3: '포장이 꼼꼼해요',
    0: '해당 없음',
};
exports.default = reviewChoiceKeywordMapping;
